module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"competitors_on_first_page":"Competitors on 1st page as of %{date}","domain":"Domain","url":"URL","position":"Position"},"fr":{"competitors_on_first_page":"Concurrents en 1ère page au %{date}","domain":"Domaine","url":"URL","position":"Position"},"de":{"competitors_on_first_page":"Konkurrenten auf der 1. Seite am %{date}","domain":"Domain","url":"URL","position":"Position"}}')
  delete Component.options._Ctor
}
